import { render, staticRenderFns } from "./PayeeSharesTable.vue?vue&type=template&id=0feeac66&scoped=true&"
import script from "./PayeeSharesTable.vue?vue&type=script&lang=js&"
export * from "./PayeeSharesTable.vue?vue&type=script&lang=js&"
import style0 from "./PayeeSharesTable.vue?vue&type=style&index=0&id=0feeac66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feeac66",
  null
  
)

export default component.exports